const base = window._env_.VUE_APP_HOST

export const getDocuments = params => {
  return http.get(`${base}/documents`, { params })
}
export const getDocument = (id, params) => {
  return http.get(`${base}/documents/${id}`, { params })
}
export const deleteDocument = id => {
  return http.delete(`${base}/documents/${id}`)
}
export const createDocument = params => {
  return http.post(`${base}/documents`, params)
}
export const createDocumentAsync = params => {
  // form-data
  params.set('async', true)
  return http.post(`${base}/documents`, params)
}
export const guestCreateDocument = params => {
  return http.post(`${base}/guest/documents`, params)
}
export const getExampleDocument = (id) => {
  return http.get(`${base}/example`, {})
}
export const setExampleDocument = params => {
  return http.post(`${base}/example`, params)
}
